const poiImages = {
  sailflow: 'https://cdn-consumer.weatherflow.com/images/markers/spot/poi-sail-smaller@2x.png',
  ikitesurf: 'https://cdn-consumer.weatherflow.com/images/markers/spot/poi-kite@2x.png',
  iwindsurf: 'https://cdn-consumer.weatherflow.com/images/markers/spot/poi-wind@2x.png',
  fishweather: null,
  windalert: null
}

export default (urlParameters) => {
  const { brand } = urlParameters
  const poiImage = brand ? poiImages[brand.toLowerCase()] : null

  jweather.poiImage = poiImage
  jweather.primaryActivity = jweather.primaryActivity?.toLowerCase() || null

  jweather.invalidToken = function (statusCode, statusMessage) {
    console.log('Invalid token handler: ' + statusCode + ' ' + statusMessage)
  }

  jweather.membershipRequired = function (feature) {
    console.log('Membership required for this feature: ')
    console.log(feature)
    alert('Membership required for this feature: ')
  }
}
